module.exports = __webpack_public_path__ + "img/logo-solena-black.ec12b783.png";